import { API_PUBLIC_HOST } from "@/_constant";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/apis/request";
import { listAddresses } from "@/apis/user-service";

const fetchAddress = createAsyncThunk('address/fetch', async ()=>{
    const response = await listAddresses();
    return response.data.response;
});

const fetchAddressByCategory = createAsyncThunk('address/fetchAddressByCategory', async (categoryId = -1) => {
    const response = await api.get(`${API_PUBLIC_HOST}/user/listAddressForCategory?categoryId=${categoryId}`)
    return response.data.response;
})

const createAddress = createAsyncThunk('address/add', async (address) => {
    const response  = await api.post(`${API_PUBLIC_HOST}/user/addAddress`, {data: address})
    return response.data.response;
});

const updateAddress = createAsyncThunk('address/update', async (address) => {
    const response = await api.post(`${API_PUBLIC_HOST}/user/addAddress`, {data:address});
    return response.data.response;
});

const deleteAddress = createAsyncThunk('address/delete', async (address)=>{
    const response = await api.delete(`${API_PUBLIC_HOST}/user/deleteAddress?addressId=${address.id}`);
    return response.data.response;
});

export {fetchAddress, fetchAddressByCategory, createAddress, deleteAddress, updateAddress};
